/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IlvlThresholdDto,
    IlvlThresholdDtoFromJSON,
    IlvlThresholdDtoToJSON,
} from '../models';

/**
 * 
 */
export class IlvlThresholdsApi extends runtime.BaseAPI {

    /**
     * Get the item level color thresholds, sorted by item level.
     */
    async ilvlThresholdsControllerGetAllRaw(): Promise<runtime.ApiResponse<Array<IlvlThresholdDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ilvl-thresholds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IlvlThresholdDtoFromJSON));
    }

    /**
     * Get the item level color thresholds, sorted by item level.
     */
    async ilvlThresholdsControllerGetAll(): Promise<Array<IlvlThresholdDto>> {
        const response = await this.ilvlThresholdsControllerGetAllRaw();
        return await response.value();
    }

}
